import { render } from "./PromoCategory.vue?vue&type=template&id=0e16caa2"
import script from "./PromoCategory.vue?vue&type=script&lang=js"
export * from "./PromoCategory.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/admin.23paskal.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__